export const BRAND_ASSETS = {
  logo: "/junkindatruck-logo.jpg",
  social: "https://junkindatruck.com/junkindatruck-brand.jpg",
  socialPath: "/junkindatruck-brand.jpg",
  favicon: "/junkindatruck-favicon.png",
  icon192: "/junkindatruck-icon-192.png",
  icon512: "/junkindatruck-icon-512.png",
};
